import React, { CSSProperties } from 'react'
import SelectInput, { SelectOption } from './SelectInput'
interface Props {
  value: string | number | boolean
  onChange: (val: string | number | boolean) => void
  label: string
  options: SelectOption[]
  containerStyles?: CSSProperties
  optionsContainerStyles?: CSSProperties
}

const NewSelect = ({
  value,
  onChange,
  label,
  options,
  containerStyles,
  optionsContainerStyles
}: Props): JSX.Element => {
  return (
    <div>
      <SelectInput
        value={value}
        onChange={(val) => {
          onChange(val)
        }}
        options={options}
        actionButtonsStyles={{
          top: '-12px',
          right: '0px',
          position: 'absolute'
        }}
        label={label}
        containerStyles={{
          borderRadius: '5px',
          border: 'none',
          outline: 'none',
          width: '120px',
          height: '31px',
          boxShadow: '0px 0px 0px 1px rgba(0,0,0,0.08), 0px 1px 2px 0px rgba(0,0,0,0.12)',
          paddingTop: '0px',
          display: 'flex',
          alignItems: 'center',
          ...containerStyles
        }}
        optionsContainerStyles={{
          top: '-5px',
          left: '0px',
          width: '200px',
          border: 'none',
          outline: 'none',
          borderRadius: '5px',
          boxShadow: '0px 0px 0px 1px rgba(0,0,0,0.08), 0px 1px 2px 0px rgba(0,0,0,0.12)',
          ...optionsContainerStyles
        }}
        chosenOptionStyles={{
          fontSize: '10px'
        }}
        chosenOptionContainerStyles={{
          padding: '2px 8px'
        }}
        closeButtonStyles={{
          position: 'absolute',
          right: '5px',
          top: '6px'
        }}
        labelStyles={{
          fontSize: '8px'
        }}
        placeholderStyles={{
          paddingTop: '0px'
        }}
      />
    </div>
  )
}

export default NewSelect
